exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".TodoStrip-header-21BIs,.TodoStrip-header-21BIs .TodoStrip-container-1AhiX{overflow:hidden}.TodoStrip-header-21BIs .TodoStrip-side-giLYB{float:right}.TodoStrip-body-CV83y .TodoStrip-expectedDuration-1N2p4{font-weight:400}.TodoStrip-body-CV83y .TodoStrip-expectedDuration-1N2p4 small{font-weight:300;font-size:14px;line-height:14px;color:#ff5766}@media (min-width:768px){.TodoStrip-body-CV83y p{width:40%}.TodoStrip-body-CV83y .TodoStrip-expectedDuration-1N2p4{width:20%}}", ""]);

// exports
exports.locals = {
	"header": "TodoStrip-header-21BIs",
	"container": "TodoStrip-container-1AhiX",
	"side": "TodoStrip-side-giLYB",
	"body": "TodoStrip-body-CV83y",
	"expectedDuration": "TodoStrip-expectedDuration-1N2p4"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/workflow/components/TodoStrip.less
// module id = 1789
// module chunks = 0